import * as React from "react";
import type { SVGProps } from "react";
const SvgBuyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="buy_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 853.333A85.333 85.333 0 0 1 42.667 768V256A85.333 85.333 0 0 1 128 170.667h768A85.333 85.333 0 0 1 981.333 256v512A85.333 85.333 0 0 1 896 853.333H128zM128 768h768V256H128v512zm128-85.333a42.667 42.667 0 1 1 0-85.334h128a42.667 42.667 0 1 1 0 85.334H256zm405.333-312.448a85.333 85.333 0 1 0 0 112.896 85.333 85.333 0 1 0 0-112.896z"
    />
  </svg>
);
export default SvgBuyIcon;
